import axios from "axios";

const ORDER_API_URL = "https://api.smorajewellery.com/api/users/orders";

const STATIC_TOKEN =
  "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTc4MDAyMzM5MCwiZXhwIjoxNzgwNjI4MTkwfQ.RAtQ6lZH4g9RjInWFjZrlPiNXBzveybzAFGNHSEgTjc";

const STATIC_PAYLOAD = {
  addressId: 2,
  products: [{ productId: 122, quantity: 1 }],
};

export interface PlaceOrderResponse {
  success: boolean;
  message: string;
  data: {
    redirectUrl: string;
  };
}

export async function placeOrder(): Promise<PlaceOrderResponse> {
  const res = await axios.post<PlaceOrderResponse>(
    ORDER_API_URL,
    STATIC_PAYLOAD,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: STATIC_TOKEN,
      },
    },
  );
  return res.data;
}
